(function($) {
	$(function() {
		//detect IE11 browser
		const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
		if(isIE11) {
			$('body').addClass('ie11');
		}

		const isMobile = {
			Android: function() {
				return navigator.userAgent.match(/Android/i);
			},
			BlackBerry: function() {
				return navigator.userAgent.match(/BlackBerry/i);
			},
			iOS: function() {
				return navigator.userAgent.match(/iPhone|iPad|iPod/i);
			},
			Opera: function() {
				return navigator.userAgent.match(/Opera Mini/i);
			},
			Windows: function() {
				return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
			},
			any: function() {
				return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
			}
		};

		if( isMobile.any() ) {
			$('.home-movie video').remove();
			$('#video-nav').remove();
		}

		const $header = $('#header'),
			$navi = $('.navi-top');
		var $header_height = $header.outerHeight();

		$(window).scroll(function() {
			$header_height = $header.outerHeight();
			$navi.css("top", $header_height);

			if ($(window).scrollTop() > 200) {
				$header.addClass('fixed');
			} else {
				$header.removeClass('fixed');
			}
		}).trigger('scroll');

		$(window).bind('load resize', function () {
			$header_height = $header.outerHeight();
			$navi.css("top", $header_height);
		}).trigger('load resize');

		$(document).ready(function() {
			$('.zoom-in, .right-to-left, .fade-up, .fade-in').each(function () {
				const delay = $(this).data('delay');

				$(this).addClass('animated')
					.css('transition-delay', delay+'s');

				$(this).on('inview', function(event, isInView, visiblePartX, visiblePartY) {
					if(isInView){
						$(this).stop().addClass('animated-active');
					}
				});
			});
			
			$('.anchor-link').click(function() {
				if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
					var target = $(this.hash);
					target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
					if (target.length) {
						$('html,body').animate({
							scrollTop: target.offset().top
						}, 1000);
						return false;
					}
				}
            });

			$('.hamburger-icon').on('click', function () {
				$(this).toggleClass('is-active');
				$header.toggleClass('has-open');
				$navi.toggleClass('is-active');

				if( $header.hasClass('has-open') ){
					stopScroll();
					navVideo();
				}else{
					resumeScroll();
				}
			});

			$('.grid').imagesLoaded(function () {
				$('.grid').masonry({
					itemSelector: '.grid-item',
					horizontalOrder: true
				});
			});
		});

		$('.kev-slider').slick({
			arrows: false,
			autoplay: true
		});
		
		$( '.slide_image' ) . slick ( {
 			 lazyLoad: 'ondemand',// or 'progressive'
 			 slidesToShow: 3,
  			 slidesToScroll: 1
		} ) ;
		
		$('.relative-slider').slick({
			prevArrow: "<span class=\"slick-prev\"></span>",
			nextArrow: "<span class=\"slick-next\"></span>",
			slidesToShow: 3,
			responsive: [
				{
					breakpoint: 641,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});

		var scrollTop = 0;
		var scrollLeft = 0;
		function stopScroll() {
			scrollTop = $(window).scrollTop();
			scrollLeft = $(window).scrollLeft();

			if($header.hasClass('fixed')) {
				$('html').addClass('noscroll header-fixed').css('top', (-scrollTop) + 'px');
			}else {
				$('html').addClass('noscroll').css('top', (-scrollTop) + 'px');
			}
		}
		function resumeScroll() {
			$('html').removeClass('noscroll header-fixed');
			$(window).scrollTop(scrollTop);
			$(window).scrollLeft(scrollLeft);
		}

		function navVideo() {
			if( $(window).width() > 768 ) {
				const vid = document.getElementById("video-nav");
				vid.defaultMuted = true;
				vid.playsinline = true;
				const videoPromise = vid.play();
				if( videoPromise !== undefined ) {
					videoPromise.then(function(){
						vid.play();
					}).catch(function(error){
						console.log(error);
					})
				}
			}
		}
	});
})(jQuery);